import type { EjectorShare } from './machineSimulation';

/** The acceptance rate of one time bucket. */
export interface AcceptRatePoint {
  /** Start of the bucket, in milliseconds. */
  time: number;
  /** Null when the machine sorted nothing in the bucket. */
  percent: number | null;
}

/** What the Sorting tab shows for a time window. */
export interface SortingView {
  accepted: number;
  /** Every outcome except accepted, each with why it was ejected. */
  ejectors: EjectorShare[];
  /** Share per size band. Absent when the machine reports no sizes. */
  sizeBands?: number[];
  /** The amount sorted in the window, formatted. */
  sorted: string;
  /** Share of ejections the ejectors missed, in percent. */
  missedEjections?: number;
  /** Acceptance rate per time bucket, oldest first. */
  acceptRateSeries?: AcceptRatePoint[];
}

/** The design writes a decimal comma: 0,8%. */
export function formatPercent(percent: number): string {
  return `${percent.toFixed(1).replace('.', ',')}%`;
}
